
import moment from 'moment'
import PageHeader from '@/components/core/PageHeader';
import tableLoading from '@/components/tableLoading';
import NoContent from '@/components/customer-content/NoContent'
import MyRentals from '@/components/customer-content/MyRentals'

export default {
  scrollToTop: true,
  components:{
    PageHeader,
    tableLoading,
    NoContent,
    MyRentals,
  },
  head() {
    return {
      title: this.title + " | Goa App",
      meta: [{
          hid: 'og:title',
          property: 'og:title',
          content: this.title + " | Goa App"
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title + " | Goa App"
        },
        {
          hid: 'robots',
          name: 'robots',
          content: 'noindex'
        },
      ],
    }
  },
  data() {
    return{
      title: 'My Rentals',
      orderId: null,
      orderData: null,
      rentals: {},
      skip: 0,
      page: 0,
      totalNumberOfpages: 0,
      loading: true,
      rentalLoading: true,
      token: null
    }
  },
  mounted() {
     if (localStorage.getItem("authToken") != (null || undefined)) {
        this.token = localStorage.getItem("authToken");
       this.getRentals(0);
      } else {
        this.$router.push({
          path: '/accounts/login/'
      })
    }
  },
  methods: {

    tConvert(timeString) {
    const [hourString, minute] = timeString.split(":");
    const hour = +hourString % 24;
    return (hour % 12 || 12) + ":" + minute + (hour < 12 ? " AM" : " PM");
},

    // callback for the pagination plugin
    callback: function (page) {
      this.page = page;
      this.storeFilters();
      let pagination = (page - 1) * 12;
      if (pagination < 0) {
        pagination = 0;
      }
      //this.scrollToElement('listing-list');
      this.getListings(pagination);
    },

    // TO get rentals using pagination
    getRentals(skip) {
      this.rentalLoading = true;
      // Add header for the API
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': this.token,
      };
      var formData = new URLSearchParams();
      formData.append("skip", skip);

      // AXIOS api call to add review api
      this.$axios.post("/api/rentalOrdersV2/app/myTickets", formData, {
        headers: headers
      })
      .then(response => {
        let value = this.getCryptKey(response.data);
        this.rentals = value;
        if (skip == 0) {
          this.page = 0;
        }
        this.totalNumberOfpages = Math.ceil(this.rentals.totalCount / 12);
        this.$nextTick(() => {
        this.rentalLoading = false;
        })
      })
      .catch(error => {
        this.$nextTick(() => {
          this.rentalLoading = false;
        })
      })
      .finally(() => {
        this.$nextTick(() => {
          this.rentalLoading = false;
        })
      })
    },
  },
}
